import {useState} from "react";
import {NokiaTimeDrivenChart} from "./charts/nokiaTimeDrivenChart";
interface dataLabel {
  summary: summary;
  trends: trends[];
}
type summary = {
  totalExpense: number;
  fuelExpense: number;
};
type trends = {
  date: number;
  runningTime: number;
};
//step 1 create a varaible like hangout

const timedata = {
  data: {
    summary: {
      totalExpense: 309276.36,
      fuelExpense: 192864.4
    },
    trends: [
      {
        date: 1743465600000,
        runningTime: 0.0
      },
      {
        date: 1746057600000,
        runningTime: 0.0
      },
      {
        date: 1748736000000,
        runningTime: 0.0
      },
      {
        date: 1751328000000,
        runningTime: 0.0
      },
      {
        date: 1754006400000,
        runningTime: 0.0
      },
      {
        date: 1756684800000,
        runningTime: 600.0
      },
      {
        date: 1759276800000,
        runningTime: 35098.96
      },
      {
        date: 1761955200000,
        runningTime: 266717.4
      },
      {
        date: 1764547200000,
        runningTime: 6860.0
      },
      {
        date: 1767225600000,
        runningTime: 0.0
      },
      {
        date: 1769904000000,
        runningTime: 0.0
      },
      {
        date: 1772323200000,
        runningTime: 0.0
      }
    ]
  }
};
export default function NokiaTimeDriven() {
  //s2 create new state with type
  const [chartsummary, setChartsummary] = useState<summary>(
    timedata.data.summary
  );
  const [charttrends, setCharttrends] = useState<any>(timedata.data.trends);
  return (
    // main
    <div>
      {/*  <div className="p-2 text-lg font-bold">Time Driven Report</div>*/}

      {/* two col start */}
      <div className="flex flex-row gap-2 p-1">
        {/* col 11 s */}
        <div className="border-gray flex w-[30%] justify-center rounded-md border p-1 pb-2">
          {/* 1 start */}
          <div className="flex flex-col">
            {/* head s */}
            <div className="flex  items-center gap-2 p-1 ">
              <div>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9689 0H1.45172C1.0667 0 0.69745 0.152949 0.425199 0.425199C0.152949 0.69745 0 1.0667 0 1.45172V15.9689C0 16.354 0.152949 16.7232 0.425199 16.9955C0.69745 17.2677 1.0667 17.4207 1.45172 17.4207H15.9689C16.354 17.4207 16.7232 17.2677 16.9955 16.9955C17.2677 16.7232 17.4207 16.354 17.4207 15.9689V1.45172C17.4207 1.0667 17.2677 0.69745 16.9955 0.425199C16.7232 0.152949 16.354 0 15.9689 0ZM15.0616 9.04241C13.8648 10.4034 12.7624 10.8834 11.7617 10.8834C10.4061 10.8834 9.23839 10.0114 8.27481 9.29192C6.53274 7.99082 5.38135 7.13158 3.44784 9.33547C3.38674 9.41275 3.31056 9.47679 3.22392 9.52368C3.13728 9.57057 3.04201 9.59933 2.9439 9.60822C2.84579 9.6171 2.7469 9.60593 2.65324 9.57536C2.55959 9.5448 2.47314 9.4955 2.39916 9.43045C2.32517 9.36541 2.2652 9.28598 2.2229 9.19702C2.1806 9.10805 2.15684 9.0114 2.15309 8.91296C2.14934 8.81452 2.16566 8.71635 2.20107 8.62442C2.23648 8.53249 2.29023 8.44873 2.35905 8.37825C5.17629 5.16541 7.47092 6.87844 9.14584 8.12873C10.8879 9.42984 12.0393 10.2891 13.9728 8.08518C14.0339 8.0079 14.1101 7.94387 14.1967 7.89698C14.2834 7.85009 14.3786 7.82132 14.4768 7.81244C14.5749 7.80355 14.6738 7.81473 14.7674 7.84529C14.8611 7.87585 14.9475 7.92516 15.0215 7.9902C15.0955 8.05525 15.1555 8.13467 15.1978 8.22364C15.2401 8.3126 15.2638 8.40925 15.2676 8.50769C15.2713 8.60613 15.255 8.7043 15.2196 8.79623C15.1842 8.88816 15.1304 8.97192 15.0616 9.04241Z"
                    fill="#349C42"
                  />
                </svg>
              </div>
              <div className="text-md font-bold">Summary</div>
            </div>
            {/* head e */}
            {/* col2 s */}
            <div className="flex gap-3 p-1">
              {/* 1 s */}
              <div className="border-gray flex flex-col items-center justify-center gap-2 rounded-xl border p-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-amber-100">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19 0C29.4871 0 38 8.51287 38 19C38 29.4871 29.4871 38 19 38C8.51287 38 0 29.4871 0 19C0 8.51287 8.51287 0 19 0ZM17.6429 8.14286V19C17.6429 19.4767 17.8922 19.9195 18.3028 20.1638L25.0885 24.2352C25.7297 24.6203 26.5643 24.4116 26.9495 23.7687C27.3346 23.1274 27.1259 22.2928 26.483 21.9077L20.3574 18.2315V8.14307C20.3574 7.39324 19.7501 6.78593 19.0002 6.78593C18.2504 6.78593 17.6429 7.39302 17.6429 8.14286Z"
                      fill="#FFC727"
                    />
                  </svg>
                </div>
                <div className="text-xs font-semibold text-gray-600">
                  Total Running Time
                </div>
                <div className="text-lg font-extrabold">
                  {chartsummary.fuelExpense}
                </div>
              </div>
              {/* 1 e */}
              {/* 2 s */}
              <div className="border-gray flex flex-col items-center justify-center gap-2 rounded-xl  border p-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-amber-100">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 0C15.2422 0 11.5687 1.11433 8.44417 3.20208C5.31964 5.28982 2.88436 8.25722 1.4463 11.729C0.0082324 15.2008 -0.368031 19.0211 0.365088 22.7067C1.09821 26.3924 2.90778 29.7778 5.56498 32.435C8.22218 35.0922 11.6077 36.9018 15.2933 37.6349C18.9789 38.368 22.7992 37.9918 26.271 36.5537C29.7428 35.1156 32.7102 32.6804 34.7979 29.5558C36.8857 26.4313 38 22.7578 38 19C37.9937 13.9628 35.9899 9.13374 32.4281 5.57191C28.8663 2.01008 24.0372 0.0062847 19 0ZM16.0769 24.8461C16.0769 25.2338 15.9229 25.6055 15.6489 25.8796C15.3748 26.1537 15.003 26.3077 14.6154 26.3077C14.2278 26.3077 13.856 26.1537 13.5819 25.8796C13.3078 25.6055 13.1539 25.2338 13.1539 24.8461V13.1538C13.1539 12.7662 13.3078 12.3945 13.5819 12.1204C13.856 11.8463 14.2278 11.6923 14.6154 11.6923C15.003 11.6923 15.3748 11.8463 15.6489 12.1204C15.9229 12.3945 16.0769 12.7662 16.0769 13.1538V24.8461ZM24.8462 24.8461C24.8462 25.2338 24.6922 25.6055 24.4181 25.8796C24.144 26.1537 23.7722 26.3077 23.3846 26.3077C22.997 26.3077 22.6252 26.1537 22.3512 25.8796C22.0771 25.6055 21.9231 25.2338 21.9231 24.8461V13.1538C21.9231 12.7662 22.0771 12.3945 22.3512 12.1204C22.6252 11.8463 22.997 11.6923 23.3846 11.6923C23.7722 11.6923 24.144 11.8463 24.4181 12.1204C24.6922 12.3945 24.8462 12.7662 24.8462 13.1538V24.8461Z"
                      fill="#FFC727"
                    />
                  </svg>
                </div>
                <div className="text-xs font-semibold text-gray-600">
                  Total Stopped Time
                </div>
                <div className="text-lg font-extrabold">
                  {chartsummary.totalExpense}
                </div>
              </div>
              {/* 2 e */}
            </div>
            {/* col2 s */}
          </div>
          {/* 1 end */}
        </div>
        {/* col 11 e */}
        {/* col 22 s */}
        <div className="border-gray flex w-[70%] flex-col rounded-xl border p-2">
          <div className="flex items-center gap-1">
            <div>
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_4176_14827)">
                  <path
                    d="M4.99128 5.26165L6.80943 2.80172C7.98467 1.21163 8.5723 0.416585 9.12054 0.584595C9.66879 0.752606 9.66879 1.72773 9.66879 3.67798V3.86186C9.66879 4.56527 9.66879 4.91698 9.89354 5.13759L9.90544 5.14902C10.135 5.36497 10.5011 5.36497 11.2332 5.36497C12.5507 5.36497 13.2094 5.36497 13.432 5.76453C13.4357 5.77114 13.4393 5.77781 13.4428 5.78453C13.6529 6.19028 13.2715 6.70631 12.5087 7.73837L10.6906 10.1983C9.51529 11.7884 8.92765 12.5834 8.37941 12.4154C7.83116 12.2474 7.83117 11.2723 7.8312 9.32199L7.8312 9.13818C7.83121 8.43476 7.83122 8.08305 7.60646 7.86243L7.59457 7.85101C7.36496 7.63505 6.9989 7.63505 6.26679 7.63505C4.94934 7.63505 4.29061 7.63505 4.06798 7.2355C4.0643 7.22888 4.06071 7.22221 4.05723 7.21549C3.84707 6.80975 4.22848 6.29372 4.99128 5.26165Z"
                    fill="#042DA6"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_4176_14827"
                    x="0"
                    y="0.5625"
                    width="17.5"
                    height="19.875"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_4176_14827"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_4176_14827"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            <div className="text-md font-bold">Running Time Trend</div>
          </div>
          <NokiaTimeDrivenChart charttrends={charttrends} />
        </div>
        {/* col 22 e */}
      </div>
      {/* two col end */}
    </div> //main
  );
}
